<template>
    <div class="pasarelas-section">
        <div class="pasarelas-content">
            <h2 class="pasarelas-title fuente-posm">
                Pasarelas de Pagos en Línea
            </h2>
            <p class="pasarelas-text fuente-nova">
                Recibe pagos en línea en tu propio sitio web. El cliente paga en línea y solo recibe su pedido, así de fácil.
            </p>
        </div>
        <div class="pasarelas-image">
            <img :src="a73" alt="Pasarelas de pagos">
        </div>
    </div>
</template>

<script>
export default {
    name: 'PasarelasPagosNew',
    data() {
        return {
            a73: require('@/assets/images/a73.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.pasarelas-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.pasarelas-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.pasarelas-image img {
    width: 400px;
    height: auto;
}

.pasarelas-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.pasarelas-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.pasarelas-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .pasarelas-title {
        font-size: 60px;
    }

    .pasarelas-text {
        font-size: 27px;
    }

    .pasarelas-image img {
        width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .pasarelas-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .pasarelas-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .pasarelas-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .pasarelas-image img {
        width: 80%;
        max-width: 320px;
    }

    .pasarelas-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .pasarelas-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
